import React from "react";
import { Card, Box, Typography } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { LineChart, Line, ResponsiveContainer, YAxis, XAxis } from "recharts";
import { Grid } from "lucide-react";

interface StatCardProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  trend?: number; // percent change
  color?: string; // accent color
  onViewAll?: () => void;
  chartData?: { value: number }[]; // array of values for mini line chart
}

const CrmStatusCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  trend,
  color = "#00AEEF",
  onViewAll,
  chartData,
}) => {
  console.log(chartData, "chartData");
  const trendColor =
    trend === undefined
      ? "text.secondary"
      : trend < 0
      ? "error.main"
      : "success.main";
  const trendText =
    trend === undefined ? "--- %" : `${trend > 0 ? "+" : ""}${trend}%`;

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "12px",
        p: 2,
        width: "100%",
        minWidth: 240,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header Section */}
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            backgroundColor: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 20,
          }}
        >
          {icon}
        </Box>

        {/* Mini Line Graph */}
        {/* Mini Line Graph */}
        <Box sx={{ width: 80, height: 40 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={chartData}
              margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            >
              <XAxis hide />
              <YAxis hide domain={["dataMin - 1", "dataMax + 1"]} />
              <Line
                type="monotone"
                dataKey="value"
                stroke={color}
                strokeWidth={2}
                dot={false}
                isAnimationActive={true}
                animationDuration={700}
                animationEasing="ease-in-out"
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </Box>

      {/* Title & Value */}
      <Box>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>
          {title}
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          {value}
        </Typography>
      </Box>

      {/* Footer Section */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        >
        <Typography variant="body2" sx={{ color: trendColor, fontWeight: 500, fontSize:"14px" }}>
          {trendText}
        </Typography>
      </Box>

      {/* View All Link */}
      <Box sx={{ display:"flex", flexDirection:"row", justifyContent:"space-between",mt: 0.5}}>
      <Box
        display="flex"
        alignItems="center"
        sx={{
          color: color,
          cursor: "pointer",
          "&:hover": { textDecoration: "underline" },
        }}
        onClick={onViewAll}
      >
        <Typography variant="body2" fontSize={"14px"}>View All</Typography>
        <ArrowForwardIcon sx={{ fontSize: 14, ml: 0.5 }} />
      </Box>
      <Box>
              <Typography variant="caption" color="text.secondary" fontSize={"14px"}>
          this month
        </Typography>
        </Box>
        </Box>
    </Card>
  );
};

export default CrmStatusCard;
